<template>
  <div id="app">
    <b-navbar toggleable="md" type="dark" variant="info">
      <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
      <b-navbar-brand to="/" @click="cur = 0">{{mydb}}</b-navbar-brand>
      <b-collapse is-nav id="nav_collapse">
        <b-navbar-nav>
          <b-nav-item v-for="(item, index) in items"
                      :key="'item' + index"
                      @click="cur = index"
                      :class="cur !== index ? '' : 'active'"
                      :to="'/'+ item"
          >{{item}}
          </b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
      <router-view/>
  </div>
</template>

<script>
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

export default {
  name: 'App',
  data: function () {
    return {
      cur: -1,
      isActive: 'Software',
      items: [ 'Home', 'Search', 'Download', 'Cite', 'About' ]
    }
  }
}

</script>

<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
  }
  .popover{
    max-width: 700px;
    width: auto;
  }
  body{
    -webkit-user-select:none;
    -moz-user-select:none;
    -ms-user-select:none;
    user-select:none;
  }
  @media print{
    .navbar {
      display: flex;
    }
    a {
      text-decoration : none;
    }
    @page {
    size: 1823px 1888px;
}
  }
</style>



// WEBPACK FOOTER //
// src/App.vue